import { Component, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { delay, take, tap } from 'rxjs/operators';

@Component({
  selector: 'aaos-app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    of(true)
      .pipe(
        take(1),
        delay(2500),
        tap(_ => {
          window.scrollTo(0, 0);
        })
      )
      .subscribe();
  }
}
